import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

import { SectionHeader } from './SectionHeader'
import { CreateCardForm } from './useCardForm'

type Props = {
  form: FormikProps<CreateCardForm>
}

export const NewCardUserSelectorForm = ({ form }: Props) => {
  const isDirty = form.getFieldMeta('employeeId')?.initialValue !== form.values.employeeId
  return (
    <>
      <SectionHeader title={i18n.t('expenses_v2.forms.fields.header_cardholder.title')} />
      <Box gap="s32">
        <EmployeeSelectorV2
          label={i18n.t('expenses_v2.forms.fields.employee.label')}
          value={form.values.employeeId ?? undefined}
          error={isDirty ? form.errors.employeeId : ''}
          onChange={(selectedEmployeeId) => {
            // We don't want to validate here as it will be done by the hook in a useEffect
            form.setFieldTouched('employeeId', true, false)
            form.setFieldValue('employeeId', selectedEmployeeId, false)
          }}
        />
      </Box>
    </>
  )
}
